export default {
      id: "detailed-medical-history-usage",
      viewBox: "0 0 34 30",
      url: __webpack_public_path__ + "sprite.svg#detailed-medical-history",
      toString: function () {
        return this.url;
      }
    }